class XmlParser {
    Parse(entrada, tag) {
        // Cria a expressão regular dinamicamente com a entrada
        let p = '(<'+tag+'>)(.*?)(<\/'+tag+'>)';
        const pattern = new RegExp(p, 'g');

        // Executa a regex na entrada
        let matches = pattern.exec(entrada);

        if (matches && matches.length >= 3) {
            // Retorna o conteúdo capturado pelo segundo grupo
            return matches[2];
        } else {
            // Retorna uma string vazia se a tag não for encontrada
            return '';
        }
    }
}

export default XmlParser;
